import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-datatransfer',
  templateUrl: './datatransfer.component.html',
  styleUrls: ['./datatransfer.component.scss']
})
export class DatatransferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
